import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-space',
  templateUrl: './space.component.html',
  styleUrls: ['./space.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpaceIconComponent {}
